import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/one-vigilance/")({
  head: () => buildRouteHead("/es/servicios/one-vigilance/", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/servicios/pharmacovigilance", replace: true });
  },
});
